import PropTypes from "prop-types";
import {
    Box,
    Button,
    IconButton,
    MenuItem,
    Modal, Select,
    TextField, Tooltip,
    Typography
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailEditor from "react-email-editor";
import {useContext, useState} from "react";
import axios from "axios";
import {html} from "@codemirror/lang-html";
import CodeMirror from "@uiw/react-codemirror";
import {DataGrid} from "@mui/x-data-grid";
import InfoIcon from "@mui/icons-material/Info";
import { useAuthState } from 'react-firebase-hooks/auth';
import {BASE_HOST, getAccountAPIHeader} from "../../../utils/urlConst";
import {SitesContext} from "../SitesProvider";
import { auth } from '../../../firebase';

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -25%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function DedicatedEmailModule(props) {

    const subjectLines = props.details.subjectLines ? props.details.subjectLines : [];
    const fileId = props.details.fileId ? props.details.fileId : "";
    const emailEditorRef = props.editorRef;
    const sites = useContext(SitesContext)
    const [selectedPreviewSite, setPreviewSite] = useState("Profitable News");
    const [previewHtml, setPreviewHtml] = useState("");
    const [showPreview, setShowPreview] = useState(false);
    const [sendPreview, setSendPreview] = useState(false);
    const [emailInput, setEmailInput] = useState("");
    const [user] = useAuthState(auth);

    const onLoad = () => {
        // editor instance is created
        // you can load your template here;
        // const templateJson = {};
        // emailEditorRef.current.editor.loadDesign(templateJson);
        if (emailEditorRef.current) {
            emailEditorRef.current.editor.loadDesign(props.editorData.design);
        } else {
            console.log("No Editor Instance?!");
        }

    }

    const onReady = () => {
        // editor is ready
        console.log('onReady');
        emailEditorRef.current.editor.addEventListener('design:updated', (dataIn) => {
            // Push Changes To Design
            props.storeChanges();
        });
    };

    const exportHtml = () => {
        emailEditorRef.current.editor.exportHtml((data) => {
            const {design, html} = data;
            console.log('exportHtml', html);
            console.log('exportDesign', JSON.stringify(design));
        });
    };

    // For Each Subjectline...
    // Fetch Stats Or Set Zero
    const slRows = [];
    const stats = props.details.subjectLineStats || {};
    console.log(props.details.subjectLineStats);
    let rIndex = 0
    for (let i = 0; i < subjectLines.length; i += 1) {
        const sl = subjectLines[i]
        let openRate = 0.0;
        let sent = 0;
        let rpm = 0.0;
        let click = 0.0;
        let newR = true;
        if (sl in stats) {
            openRate = stats[sl].open;
            sent = stats[sl].sent;
            rpm = stats[sl].rpm;
            click = stats[sl].click;
            newR = false;
        }
        slRows.push({
            "id": i,
            "subjectline": sl,
            "sent": sent,
            "open": openRate,
            "rpm": rpm,
            "click": click,
            "disabled": false,
            "new": newR
        });
        rIndex += 1;
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(stats)) {
        if (subjectLines.indexOf(key) === -1) {
            slRows.push({
                "id": rIndex,
                "subjectline": key,
                "sent": value.sent,
                "open": value.open,
                "click": value.click,
                "rpm": value.rpm,
                "disabled": true
            });
            rIndex += 1;
        }
    }
    console.log(slRows);
    // Add Additional Rows Of Historical Subject Lines
    return (<div>
        <Typography>
            Details For Dedicated Email
        </Typography>
        <br/>
        <TextField id={`file-id-input`} label="File ID" variant="outlined" value={fileId}
                   onChange={(e) => {
                       props.setDetails({...props.details, "fileId": e.target.value})
                       console.log(`Change? ${fileId.length}`)
                   }}
                   disabled={props.details.created}
                   error={fileId.length < 1}
                   color={fileId.length >= 1 ? 'success' : 'error'}
        />&nbsp;
        <Button variant="contained" color={"warning"}
                disabled={props.details.created}
                onClick={() => {
                    user.getIdToken().then((idToken) => {
                        axios.get(`${BASE_HOST}/api/basic/nextFileId`, getAccountAPIHeader(idToken))
                          .then(res => {
                              props.setDetails({ ...props.details, "fileId": `${res.data.id}` })
                          });
                    })
                }}
        >Generate<br/> New FileId</Button>
        <Tooltip style={{"marginTop": ".25em"}} title={
            <Typography>
                FileId's should represent unique piece of content. They copied from HasOffers. <br/><br/>
                However if your adding content that won't be found in has offer use the "generate new id" button to get an unused Id. <br/><br/>
                For Example if you're split testing new copy, but don't want to first upload it to has offer use a new Id instead. <br/><br/>
                Wrong ID's will effect the machines ability to optimize.
            </Typography>
        }>
            <IconButton>
                <InfoIcon/>
            </IconButton>
        </Tooltip>
        <br/><br/>
        <Typography align="left" variant={"h5"}>
            Subject Lines&nbsp;&nbsp;&nbsp;
            <IconButton aria-label="create" onClick={() => {

                props.setDetails({...props.details, "subjectLines": ["", ...subjectLines]})
                // props.setSuppressions([...suppressions, ""])
            }}>
                <AddCircleIcon color={"success"}/>
            </IconButton>
        </Typography>

        <div style={{height: 400, width: '85%', marginLeft: '5.5%', borderStyle: "dotted", borderColor: "#699d8a"}}>
            <DataGrid
                rows={slRows}
                columns={[
                    {
                        field: 'subjectline', headerName: "Subject", flex: 1, minWidth: 150, editable: true,
                        valueSetter: (params) => {
                            console.log("Look Here...");
                            console.log(params);
                            // Trigger A Re-Render
                            if (!params.row.disabled && subjectLines.indexOf(params.value) === -1) {
                                const supp = [...subjectLines];
                                supp[params.row.id] = params.value
                                props.setDetails({...props.details, "subjectLines": supp})
                            }


                            // Return Empty Result.
                            return params.row;
                        },
                    },
                    {
                        field: 'sent', headerName: "Sent", type: "number",
                        valueFormatter: (params) => `${params.value.toLocaleString()}`
                    },
                    {
                        field: 'open', headerName: "Open Rate", type: "number",
                        valueFormatter: (params) => `${(params.value * 100).toFixed(2).toLocaleString()} %`
                    },
                    {
                        field: 'click', headerName: "CTR", type: "number",
                        valueFormatter: (params) => `${(params.value * 100).toFixed(2).toLocaleString()} %`
                    },
                    {
                        field: 'rpm', headerName: "RPM", type: "number",
                        valueFormatter: (params) => `$${params.value.toFixed(2).toLocaleString()}`
                    },

                    {
                        field: "delete",
                        headerName: "Delete",
                        width: 75,
                        renderCell: (params) => params.row.disabled ? "-" :
                            <IconButton aria-label="delete" onClick={() => {
                                console.log(params);
                                if (!params.row.disabled) {
                                    const supp = [...subjectLines];
                                    supp.splice(params.row.id, 1);
                                    props.setDetails({...props.details, "subjectLines": supp})
                                }
                            }}>
                                <DeleteIcon/>
                            </IconButton>

                    }

                ]}
                experimentalFeatures={{newEditingApi: true}}
                pageSize={50}
                rowsPerPageOptions={[50]}
                disableSelectionOnClick
                getRowClassName={(params) => {
                    if (params.row.disabled) {
                        return "row-disabled-color";
                    }
                    if (params.row.subjectline.length < 4) {
                        return "row-edit-error";
                    }
                    if (params.row.new) {
                        return "row-new-styling";
                    }
                    return "row-default-styling";

                }}
            />
        </div>
        <br/><br/>
        <Typography align="left" variant={"h5"}>
            Pre-Header&nbsp;&nbsp;&nbsp; <br/><br/>
            <TextField id={`Preheader-input`} label="Preheader" minRows={3} multiline variant="outlined"
                       value={props.details.preheader ? props.details.preheader : ""}
                       onChange={(e) => {
                           // console.log(e.target.value);
                           props.setDetails({...props.details, "preheader": e.target.value})
                       }}
                       style={{"marginLeft": "1.5em"}}
            />
        </Typography>
        <br/><br/>
        <Typography align="left" variant={"h5"}>Dedicated Signature (Html)</Typography>
        <CodeMirror
            value={props.details.signature || ''}
            height="200px"
            style={{"color": "black"}}
            width="45%"
            extensions={[html()]}
            onChange={(v1, v2) => console.log(props.setDetails({...props.details, "signature": v1}))}
        />
        <br/><br/>
        <Typography align="left" variant={"h5"}>Dedicated Disclaimer (Html)</Typography>
        <CodeMirror
            value={props.details.disclaimer || ''}
            height="200px"
            style={{"color": "black"}}
            width="45%"
            extensions={[html()]}
            onChange={(v1, v2) => console.log(props.setDetails({...props.details, "disclaimer": v1}))}
        />
        <br/><br/>
        <div style={{textAlign: "center"}}>
            <Button variant="contained" color={"warning"}
                    onClick={() => {
                        user.getIdToken().then((idToken) => {
                        axios.post(`${BASE_HOST}/api/basic/reload-creative`, {
                            "fileId": props.details.fileId
                        }, getAccountAPIHeader(idToken)).then((r) => {
                            emailEditorRef.current.editor.loadDesign(r.data.design);
                            if (r.data.subjectLines) {
                                const updatedDetails = {...props.details, "subjectLines": r.data.subjectLines};
                                if (r.data.preheader != null) {
                                    updatedDetails.preheader = r.data.preheader;
                                }
                                props.setDetails(updatedDetails);
                            }
                        }) })
                    }}
            >Re-Import
                <Tooltip style={{}} title={
                    <Typography>
                        Re-Extracts creative For fileId in Has Offers. <br/>
                        Useful if creative in has offer has changed.
                    </Typography>
                }>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button variant="contained" color={"info"}
                    onClick={() => {
                        emailEditorRef.current.editor.loadDesign(props.details.design);
                    }}
            > Reset
                <Tooltip style={{}} title={
                    <Typography>
                        Resets To Pre-Edit State
                    </Typography>
                }>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button variant="contained" color={"primary"}
                    onClick={() => {
                        emailEditorRef.current.editor.exportHtml((data) => {
                            const {design, html} = data;
                            user.getIdToken().then((idToken) => {
                                axios.post(`${BASE_HOST}/api/basic/beautify-email`, {
                                    "design": design,
                                    "fileId": props.details.fileId
                                }, getAccountAPIHeader(idToken)).then((r) => {
                                    emailEditorRef.current.editor.loadDesign(r.data.design);
                                })
                            })
                        });

                    }}
            > Beautify HTML
                <Tooltip style={{}} title={
                    <Typography>
                        Makes html pretty by bolding text, adding links, and adding call outs.
                    </Typography>
                }>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button variant="contained" color={"error"}
                    onClick={() => {
                        emailEditorRef.current.editor.loadDesign(props.details.originalImport.design);
                    }}
            > Reset To HO State
                <Tooltip style={{}} title={
                    <Typography>
                        Resets to original html from has offers
                    </Typography>
                }>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
            </Button>

        </div>
        <EmailEditor
            ref={emailEditorRef}
            options={{
                features: {
                    textEditor: {
                        cleanPaste: false
                    },
                    preheaderText: false,
                    svgImageUpload: true,
                    spellChecker: true,
                    audit: true,
                    colorPicker: {
                        presets: ['#0000ff', '#347c2c', '#313131', '#313131']
                    },

                },

                specialLinks: [
                    {
                        name: 'OFFER URL',
                        href: '{tracking_link}',
                        target: '_self',
                    }
                ],
                customCSS: [
                    ".disclaimer{font-size: 14px; color: gray;}",
                    `
                      img{
                            max-height: min(65vh, 700px);
                        }
            
                        h1{
            
                        }
            
                        h1 > a{
                            font-size: 24px  !important;
                            color: #000000 !important;
                            text-decoration: none !important;
                            font-weight: bold;
                            max-width: 85%;
                            display: block;
                            text-align: center;
                            margin: auto;
                        }
            
                        h2 > a{
                            text-decoration: none !important;
                            font-size: 22px !important;
                            color: #1f9701 !important;
                            font-style: italic;
                            font-weight: bold;
                            display: block;
                            max-width: 92.5%;
                            text-align: center;
                        }
            
                        .primary-link{
                            font-size: 18px  !important;
                            text-decoration: underline;
                            font-weight: bold;
                            color: #0000ff;
                        }
            
                        .secondary-link{
                            font-size: 18px  !important;
                            text-decoration: underline;
                            color: #347c2c;
                            font-weight: bold;
                        }
            
                        .button{
                            display: block;
                            text-align: center;
                            max-width: 55%;
                            margin: 0 auto;
                            border-top: 0px solid transparent;
                            text-decoration: none;
                            color: #ffffff !important;
                            background-color: #029544;
                            border-radius: 4px;
                            font-weight: 400;
                            border-right: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-left: 0px solid transparent;
                            font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                            padding: 0.65em;
                        }
                    `
                ]
            }}
            projectId={104696}
            onLoad={onLoad}
            onReady={onReady}
            onPaste={(e) => {
                console.log("TODO Clipboard");
                console.log(e.clipboardData.getData('Text'));
            }}
        />

        {/* <Button onClick={() => exportHtml()}> Export Or Some Shit</Button> <br/> */}
        <Button onClick={() => {
            user.getIdToken().then((idToken) => {
            emailEditorRef.current.editor.exportHtml((data) => {
                const { design, html } = data;
                console.log("Request for ");
                console.log(selectedPreviewSite);
                axios.post(`${BASE_HOST}/api/basic/format-email`, {
                    "html": html,
                    "ad": props.details,
                    "site": selectedPreviewSite
                }, getAccountAPIHeader(idToken)).then((r) => {
                    setPreviewHtml(r.data.html);
                    setShowPreview(true);
                })
                })
            });
        }}>Preview</Button> <br/>
        <Button onClick={() => {
            setSendPreview(true)
        }}>Send Preview</Button> <br/>
        <br/><br/>
        <Modal
            open={sendPreview}
            onClose={() => {
                setSendPreview(false);
            }}
            aria-labelledby="email-preview-modal"
            aria-describedby="email-preview-modal-description"
            style={{"overflowY": "scroll"}}
        >
            <Box sx={{...modalStyle}}
                 style={{"maxHeight": "calc(100vh - 210px)", "overflowY": "auto", "minWidth": "600px"}}>
                <h1>Get Email Sent To Your Inbox</h1>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedPreviewSite}
                    label="Select Site To Render As"
                    onChange={(e) => {
                        setPreviewSite(e.target.value);

                    }}
                >
                    {sites.sites.map((s) => <MenuItem value={s} key={`option${s}`}>{s}</MenuItem>)}
                </Select><br/>
                <TextField id="email-outlined" label="Email Address" variant="outlined" type={"email"}
                   value={emailInput}
                   onChange={(e) => {
                       setEmailInput(e.target.value)
                   }}
                /><br/>

                <Button onClick={()=>{
                    user.getIdToken().then((idToken) => {
                    emailEditorRef.current.editor.exportHtml((data) => {
                        const { design, html } = data;
                        axios.post(`${BASE_HOST}/api/basic/send-sample-email`, {
                            "html": html,
                            "ad": props.details,
                            "site": selectedPreviewSite,
                            "email": emailInput,
                        }, getAccountAPIHeader(idToken)).then((r) => {
                            setSendPreview(false);
                        })
                    })

                        });
                    setSendPreview(false);
                }}>Send</Button>
            </Box>
        </Modal>

        <Modal
            open={showPreview}
            onClose={() => {
                setShowPreview(false);
            }}
            aria-labelledby="email-preview-modal"
            aria-describedby="email-preview-modal-description"
            style={{"overflowY": "scroll"}}
        >
            <Box sx={{...modalStyle}}
                 style={{"maxHeight": "calc(100vh - 210px)", "overflowY": "auto", "minWidth": "600px"}}>

                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedPreviewSite}
                    label="Select Site To Render As"
                    onChange={(e) => {
                        setPreviewSite(e.target.value);
                        emailEditorRef.current.editor.exportHtml((data) => {
                            const {design, html} = data;
                            user.getIdToken().then((idToken) => {
                                axios.post(`${BASE_HOST}/api/basic/format-email`, {
                                    "html": html,
                                    "ad": props.details,
                                    "site": e.target.value
                                }, getAccountAPIHeader(idToken)).then((r) => {
                                    setPreviewHtml(r.data.html);
                                    setShowPreview(true);
                                })
                            })
                        });
                    }}
                >
                    {sites.sites.map((s) => <MenuItem value={s} key={`option${s}`}>{s}</MenuItem>)}
                </Select>

                <iframe srcDoc={previewHtml} seamless width="600px" title={`Email_${fileId}`}/>
                <br/><br/><br/>
                <Button color="warning" size="large" variant={"contained"} onClick={() => {
                    setShowPreview(false);
                }}>Close</Button>
            </Box>
        </Modal>

    </div>);
}

DedicatedEmailModule.propTypes = {
    details: PropTypes.object,
    setDetails: PropTypes.func,
    storeChanges: PropTypes.func,
    editorData: PropTypes.object
}